import { Map } from "ol";
import { Control } from "ol/control";
// listen to the Editor events and to the map events
import { nbfOrUsageChecked, referencePointTriggered, referencePointSet, referencePointExists, referenceMarkerParams } from "../../events";
import { Subscription } from "rxjs";

export class ReferencePointControl extends Control {

    map!: Map;
    nbfOrUsageCheckedSubscription: Subscription | undefined;
    referencePointSetsubscription: Subscription | undefined;
    referencePointExistsSubscription: Subscription | undefined;
    buttonElement: any | null = null


    constructor(map: Map) {  
        let arrowRight = document.createElement('button')
        arrowRight.innerHTML = 'P'
        let elem = document.createElement('div')
        elem.className = 'bottom-left-button ol-control disabled'
        elem.append(arrowRight)

        super({
            element: elem
        })
        this.map = map
        this.buttonElement = elem;
        this.buttonElement.addEventListener('click', this.triggerReferencePoint.bind(this), false)
        this.buttonElement.title = $localize`:@@p-button-info:Adding a reference point is enabled when NBF or multiple usage is selected.`;

        // set active/disabled classes based on editor and map events: 
        // when clicked on nbf/nbf-revidiert, set active class
        // when clicked on map, remove active class
        // when nbf checkbox not checked, set disabled class
        this.nbfOrUsageCheckedSubscription = nbfOrUsageChecked.subscribe((params: referenceMarkerParams) => {
            console.log('*** nbfOrUsageCheckedSubscription', params.checked, params.nbf);
            if (params.checked) {
                this.buttonElement.classList.remove('disabled');
                this.buttonElement.classList.add('active');
                this.triggerReferencePoint(params);
            } else {
                this.buttonElement.classList.remove('active');
                this.buttonElement.classList.add('disabled');
                this.triggerReferencePoint(params);
            }
        });

        this.referencePointSetsubscription = referencePointSet.subscribe(() => {
            console.log('*** referencePointSetsubscription');
            this.buttonElement.classList.remove('active');
        });

        this.referencePointExistsSubscription = referencePointExists.subscribe(() => {
            console.log('*** referencePointExistsSubscription');
            this.buttonElement.classList.remove('disabled');
        });
    }



    triggerReferencePoint(params: any) { //checked: boolean, nbf: boolean) {
        // console.log('*** triggerReferencePoint', params);
        if (params.type === 'click' && this.buttonElement.classList.contains('disabled')) {
            return;
        }
        if (params.hasOwnProperty('checked') && params.hasOwnProperty('nbf')) {
            if (params.checked) {   
                this.buttonElement.classList.add('active');
            }
            // send event to start listening in map component
            referencePointTriggered.next(params);
        } else {
            referencePointTriggered.next({checked: true, nbf: undefined});
        }

    }
}